import Vue from 'vue'
import 'vxe-table/lib/index.css'
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
Vue.use(XEUtils)
Vue.use(VXETable)
